import { Pipe, PipeTransform } from '@angular/core';
import { SalesOrderStatusService } from 'src/app/services/salesorderstatus.service';

@Pipe({
  name: 'orderStatus',
  pure: false 
})
export class OrderStatusPipe implements PipeTransform {

  orderstatus: any;

  constructor(private orderstatusService: SalesOrderStatusService,
  ) {

  }

  transform(val: any): any {

  


if(val.length>0){
  // console.log(val);
  this.orderstatusService.getOrderStateById(val).subscribe(
    res => {

      this.orderstatus = res['label'];
      console.log("error",res);
      let value= this.orderstatus

    },
    error => {
       console.log("error",error);
       
    }
  )
  return this.orderstatus;

}

}


}
